import { SET_CART_DATA, SET_QUESTIONS_DATA, UPDATE_CART_DATA, UPDATE_QUESTIONS_DATA, UPDATE_CART_STATUS, UPDATE_QUESTIONS_STATUS, } from "./types";
export function setCartData(data) {
    return {
        type: SET_CART_DATA,
        payload: data,
    };
}
export function updateCartData(push) {
    return {
        type: UPDATE_CART_DATA,
        payload: push,
    };
}
export function setQuestionsData(data) {
    return {
        type: SET_QUESTIONS_DATA,
        payload: data,
    };
}
export function updateQuestionsData(push) {
    return {
        type: UPDATE_QUESTIONS_DATA,
        payload: push,
    };
}
export function updateCartStatus(status) {
    return {
        type: UPDATE_CART_STATUS,
        payload: status,
    };
}
export function updateQuestionsStatus(status) {
    return {
        type: UPDATE_QUESTIONS_STATUS,
        payload: status,
    };
}
